/**
 * The wire shape `GET /api/status/providers` returns (`PublicProviderResponse` in `Rws.AiInsights.Host.Status`): every AI tool the portal
 * covers, from the vendor plugins it was deployed with. The endpoint is `AllowAnonymousAccess`, because the signed-out landing page names
 * the tools from it; it holds nothing about any person.
 */
import { adminRequest, type AdminResult } from "./adminApi";

/** How a provider charges: a flat fee with no limit, or metered usage that a per-person limit can cap. */
export type ProviderCostModel = "FlatFee" | "Metered";

/** One AI tool the portal covers. */
export interface PublicProvider {
  vendorId: string;
  displayName: string;
  costModel: ProviderCostModel;
}

/** Calls `GET /api/status/providers`. */
export async function fetchPublicProviders(): Promise<AdminResult<PublicProvider[]>> {
  return adminRequest<PublicProvider[]>("/api/status/providers", { method: "GET" }, "providers");
}
